<!--新增分摊项目-->
<template>
	<div>
		<el-dialog :title="title" :visible.sync="addTemplateShow">
			<el-form>
				<el-form-item label="分摊项目名称" :label-width="formLabelWidth" :required="nonEmpty">
					<el-input v-model="itemName" autocomplete="off" placeholder="请输入分摊项目名称"></el-input>
				</el-form-item>
				<center>
					<div>
						<div style="margin-left:40px;margin-right:40px;margin-top:0px; margin-bottom:0px; width:500px;">
							<elCheckBoxTree :dds="leftDefaultDevices" @checkItem="checkItemLeft" :dataList='virtualDeviceList' style="height:400px; width:500px;"></elCheckBoxTree>
						</div>
						<div style="margin:40px; display:none;">
							<elCheckBoxTree @checkItem="checkItemRight" :dataList='virtualDeviceList' style="height:400px;"></elCheckBoxTree>
						</div>
					</div>
				</center>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addTemplateShow = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import elCheckBoxTree from './elCheckBoxTree.vue'
	export default {
		components: {
			elCheckBoxTree,
		},
		props: {
		},
		data() {
			return {
				itemId: '',
				itemName: '',
				type: 2,
				formLabelWidth: '130px',
				addTemplateShow: false,
				selectDeviceListLeft: [], //选中的设备
				selectDeviceListRight: [], //选中的设备
				isEdit: true, //是否为编辑
				nonEmpty:true,//显示红星
				leftDefaultDevices:[],
				rightDefaultDevices:[],
			}
		},
		created() {
		},
		mounted() {
		},
		destroyed() {},
		computed: {
			title(){
				if(this.type == 2){
					return '增加公共用电分摊荐（内部）';
				}else if(this.type == 3){
					return '增加公共用电分摊荐（外部）';
				}
			},
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
		},
		watch: {
			leftDefaultDevices(nv, ov){
				console.log("addItemDialog.leftDefaultDevices改变");
			}
		},
		methods: {
			checkItemLeft(list) {
				this.selectDeviceListLeft = list
			},
			checkItemRight(list) {
				this.selectDeviceListRight = list
			},
			confirm() {
				if(this.itemName.length == 0){
					this.$message.error('请输入分摊项目名称');
					return;
				}
				var deviceNoLeft = [];
				for(var i=0; i<this.selectDeviceListLeft.length; i++){
					deviceNoLeft[deviceNoLeft.length] = this.selectDeviceListLeft[i].no;
				}
				var deviceNoRight = [];
				if(isempty(deviceNoLeft)) {
					this.$message.error('请选择设备');
					return
				}
				this.$api.tcFentanApi.addDivideItem(
					this.itemId,
					this.itemName,
					this.type,
					deviceNoRight,
					deviceNoLeft
					,
					respon => {
						this.$message.success('新增公共（内部）分摊项目成功');
						this.$emit('addItemSuccess');
						this.addTemplateShow = false;
					}, failure => {
						this.$message({
							type: 'error',
							message: failure
						});
					}
				)
			},
		}
	}
</script>

<style>
	.addNewOwnerDialogBody {
		/*width: 100%;
		 height: 100%;*/
	}
	
	.addNewOwnerDialogBody .dialog-from {
		width: calc(100% - 3.3rem);
		height: 100%;
	}
	
	.dialog-device {
		height: 710px;
		margin-left: 40px;
	}
	
	.addNewOwnerDialogBody .el-dialog__body {
		display: flex;
		align-items: center;
		padding: 0;
	}
</style>